module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Cook Together, Eat Together"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('em', [_vm._v("Cook Together, Eat Together")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('strong', [_vm._v("Never Underestimate the Power of a Good Meal")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you want to bring your family together, the kitchen is a good place to start. Cooking and eating together is a great way to build family closeness. But when budgets are tight, it is a challenge to put a meal on the table. We hope this book makes that process easier and more enjoyable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To create this book, we listened to people who are experts on this topic, mothers across Kentucky who are SNAP (Supplemental Nutrition Assistance Program) eligible and who know how to stretch a dollar to feed their families.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though it is a challenge to cook when funds are limited, having good basic cooking skills makes it easier. Kentucky moms told us about friends who “can throw down in the kitchen” and “who can make something from nothing.” They said their kids became more independent and confident when they helped out in the kitchen. Families also found it was fun to cook together, as a team, and that cooking teaches many skills—from organization to math.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kentucky mothers said that learning to cook well boosted their confidence and reduced their stress. And, when the cooking was done, families found they looked forward to sitting down to a home-cooked meal together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The topics we have covered and the types of recipes we chose were based on things that real people told us would be helpful. Comments from the mothers we talked with are in quotation marks throughout the book so you can share in their humor and learn from their wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg1_1.jpg"
    }
  })])]), _c('p', {
    staticClass: "h1a",
    attrs: {
      "id": "int_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('strong', [_vm._v("Basics for Healthy Eating on a Budget")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Best Buys.")]), _vm._v(" Dried beans, eggs, cabbage, bananas, cornmeal and oatmeal are among the most nutritious foods for the money. Learn to make delicious foods with these basics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Eat Smaller Portions.")]), _vm._v(" Eat less, spend less, weigh less. Serve smaller portions at dinner and you may have enough for lunch the next day. Big muffins can be split in half. One half cup is a serving size for rice, noodles and cereals; but many people eat a cup or two. A serving of meat is 3 ounces, about the size of a deck of cards. One way to eat less is to serve food on smaller plates—it makes the portions appear bigger.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Waste Not.")]), _vm._v(" Americans throw away roughly 30 million tons of food each year. Before you put perishables in your grocery cart, think about how and when you’ll use them. When you buy perishables, wrap them well so they stay fresher longer. When vegetables become slightly wilted and are not good for a salad, use them in a soup, stew or omelet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Think Frozen.")]), _vm._v(" With frozen foods, you can use the amount you need, reseal the bag and reduce waste. Use plain frozen vegetables. Vegetables frozen in butter sauce cost twice as much and have far more calories.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Go Generic.")]), _vm._v(" Buy store brands instead of pricier national brands. Many grocery companies buy national-brand products and put their own label on them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Less Meat.")]), _vm._v(" Try serving smaller portions of meat; extend the meal by serving more whole grains, beans and vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Buy Produce in Season.")]), _vm._v(" Check the grocery ads in your newspaper to find the week’s best buys. Many Kentucky farmers markets accept SNAP benefits.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Use Sales and Coupons.")]), _vm._v(" Planning meals around what’s on sale can lower your grocery bills, especially if you also use coupons. Just make sure they’re for items you would buy anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Brown-Bag It.")]), _vm._v(" Packing lunch is a great way to save money and an excellent use of leftovers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Plan Ahead.")]), _vm._v(" Shopping with specific meals in mind for the week ahead makes it easier to buy in bulk and repurpose ingredients. For example, turn Sunday night’s roast chicken into Monday night’s enchiladas. The more you cook from scratch, the further your dollar can stretch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Water First.")]), _vm._v(" Don’t buy sodas and other drinks. Make water your main beverage, and watch your food costs and calories drop. American families spend on average $850 a year on soft drinks. Tap water costs a penny a gallon. Drink water first.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('strong', [_vm._v("Buying Spices Can Be Pricey.")]), _vm._v(" Spices seem expensive but because you use small amounts of them, they go a long way. Consider buying one spice a month. If you can shop at ethnic markets, you may be able to find good deals on spices.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/cmn.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/cmna.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00dd4543","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Introduction.vue
// module id = 69
// module chunks = 0